<script setup lang="ts">
import { CheckCircle2, Info, XCircle, AlertTriangle, X } from "lucide-vue-next"
import type { Toast } from "@/stores/toast"

defineProps<{ toast: Toast }>()
defineEmits<{ dismiss: [id: number] }>()

const iconFor = {
  info: Info,
  success: CheckCircle2,
  warning: AlertTriangle,
  error: XCircle,
} as const

const colorFor = {
  info: "border-border-default text-fg",
  success: "border-emerald-700 text-emerald-200",
  warning: "border-amber-700 text-amber-200",
  error: "border-red-700 text-red-200",
} as const
</script>

<template>
  <div
    :class="[
      'flex items-start gap-3 p-3 pr-2 rounded-md bg-card border shadow-lg',
      'min-w-[280px] max-w-md',
      colorFor[toast.kind],
    ]"
    role="alert"
  >
    <component :is="iconFor[toast.kind]" :size="18" class="shrink-0 mt-0.5" />
    <div class="flex-1 text-sm leading-snug">{{ toast.message }}</div>
    <button
      class="text-muted hover:text-fg p-1"
      aria-label="Dismiss"
      @click="$emit('dismiss', toast.id)"
    >
      <X :size="14" />
    </button>
  </div>
</template>
